import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

// Fetch all blogs
export const getBlogs = async () => {
  try {
    const response = await api.get(`${API_URL}/blogs`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};

// Add a new blog
export const addBlog = async (blog) => {
  try {
    const response = await api.post(`${API_URL}/blogs`, blog,{
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};

// Update a blog
export const updateBlog = async (id, blog) => {
  try {
    const response = await api.put(`${API_URL}/blogs/${id}`, blog,{
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};


// Update an astrologer status
export const updateBlogStatus = async (id, updateStatusObj) => {
  try {
    const response = await api.put(`${API_URL}/blogs/status/${id}`, updateStatusObj);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};

// Delete a blog
export const deleteBlog = async (id) => {
  try {
    const response = await api.delete(`${API_URL}/blogs/${id}`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};
